module.exports = __webpack_public_path__ + "img/negah-logo.a690be9b.jpg";